export default "__VITE_ASSET__CeZF3qTB__"